/**
 * vjiang
 * 20200828153600
 * report interface
 */
import request from '@/utils/request';

/**
 * 获取体检报告
 * @param params
 */
export function getReportList(params) {
    return request({
        url: "/business/reportQuery",
        method: 'get',
        params: params
    })
}

/**
 * 单条获取
 */
export function getReport(params) {
    return request({
        url: "/business/reportDetailQuery",
        method: 'get',
        params: params
    })
}
